"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { queryClient } from "@/config/react-query";
import { TenantContext, useTenant } from "@/contexts/tenant-context";
import { withReturnTo } from "@/lib/redirect-utils";
import { setGlobalTenantDefaultTimezone } from "@/lib/timezone";
import { TenantContext as TenantContextType } from "@/types/ai";
import { PrivateTenant } from "@/types/tenant";
import { useUser } from "./user-provider";
import { fetchPrivateTenant } from "@/api/tenant";
import { authService } from "@/services/auth-service";
import { useTenantStore } from "@/stores/tenant-store";
export { TenantContext, useTenant };
export function TenantProvider(t0) {
  const $ = _c(30);
  const {
    children
  } = t0;
  const [tenant, setTenant] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const pathname = usePathname();
  const router = useRouter();
  const {
    refetchUser
  } = useUser();
  const {
    setCurrentTenant
  } = useTenantStore();
  let t1;
  if ($[0] !== tenant?.subDomain) {
    t1 = () => {
      if (tenant?.subDomain) {
        queryClient.clear();
      }
    };
    $[0] = tenant?.subDomain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = tenant?.subDomain;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  let t4;
  if ($[4] !== tenant?.defaultTimezone) {
    t4 = () => {
      setGlobalTenantDefaultTimezone(tenant?.defaultTimezone ?? null);
    };
    $[4] = tenant?.defaultTimezone;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = tenant?.defaultTimezone;
  let t6;
  if ($[6] !== t5) {
    t6 = [t5];
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  useEffect(t4, t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  useEffect(_temp2, t7);
  let t8;
  if ($[9] !== pathname || $[10] !== refetchUser || $[11] !== router || $[12] !== setCurrentTenant || $[13] !== tenant) {
    t8 = () => {
      const loadTenant = async () => {
        const tenantName = pathname.split("/")[1];
        if (tenantName === "login") {
          setTenant(null);
          setCurrentTenant(null);
          return;
        }
        if (tenantName && (!tenant || tenant.subDomain !== tenantName)) {
          if (tenant && tenant.subDomain !== tenantName) {
            queryClient.clear();
          }
          setIsLoading(true);
          const fetchedTenant = await fetchPrivateTenant();
          if (fetchedTenant) {
            setTenant(fetchedTenant);
            setCurrentTenant(fetchedTenant.subDomain);
            authService.setInactivityTimeout(fetchedTenant?.authTimeoutMs ?? null);
            if (pathname === `/${tenantName}`) {
              router.prefetch(`/${tenantName}${fetchedTenant.homePage || "/dashboard"}`);
            }
            await refetchUser(tenantName);
          } else {
            const returnTo = typeof window !== "undefined" ? window.location.pathname + window.location.search : null;
            router.push(withReturnTo("/login", returnTo));
          }
          setIsLoading(false);
        }
      };
      loadTenant();
    };
    $[9] = pathname;
    $[10] = refetchUser;
    $[11] = router;
    $[12] = setCurrentTenant;
    $[13] = tenant;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== pathname || $[16] !== refetchUser || $[17] !== setCurrentTenant || $[18] !== tenant) {
    t9 = [pathname, tenant, refetchUser, setCurrentTenant, queryClient];
    $[15] = pathname;
    $[16] = refetchUser;
    $[17] = setCurrentTenant;
    $[18] = tenant;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  useEffect(t8, t9);
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = async () => {
      const fetchedTenant_0 = await fetchPrivateTenant();
      if (fetchedTenant_0) {
        setTenant(fetchedTenant_0);
        authService.setInactivityTimeout(fetchedTenant_0?.authTimeoutMs ?? null);
      }
      return fetchedTenant_0;
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const refetchTenant = t10;
  let t11;
  if ($[21] !== tenant) {
    t11 = tenant ? {
      name: tenant.name,
      clinicType: tenant.clinicType,
      timezone: tenant.defaultTimezone
    } : undefined;
    $[21] = tenant;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const tenantContext = t11;
  let t12;
  if ($[23] !== isLoading || $[24] !== tenant || $[25] !== tenantContext) {
    t12 = {
      tenant,
      isLoading,
      tenantContext,
      refetchTenant
    };
    $[23] = isLoading;
    $[24] = tenant;
    $[25] = tenantContext;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== children || $[28] !== t12) {
    t13 = <TenantContext.Provider value={t12}>{children}</TenantContext.Provider>;
    $[27] = children;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp2() {
  return _temp;
}
function _temp() {
  return setGlobalTenantDefaultTimezone(null);
}
export default TenantProvider;